/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { MessageCenter } from "utils";

import Button, { ButtonContainer } from 'components/Button';

import {
  TeamsSection,
  ContactsSection,
  GeneralSection
} from './sections/index';

export default function Teams({
  idPerson,
  formikProps,
  formikRef,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  teamsGroup,
  setTeamsGroup,
  teamsGroupToDelete,
  setTeamsGroupToDelete,
  contactsGroup,
  setContactsGroup,
  contactsGroupToDelete,
  setContactsGroupToDelete,
  SECTIONS,
  refQuestionnaireSent,
  submitFunction,
}) {
  const mc = new MessageCenter();

  return (
    <>
      <TeamsSection.components.RenderSection
        formikProps={formikProps}
        formikRef={formikRef}
        idProduct={idProduct}
        globalQuestionnaire={globalQuestionnaire}
        setGlobalQuestionnaire={setGlobalQuestionnaire}
        teamsGroup={teamsGroup}
        setTeamsGroup={setTeamsGroup}
        teamsGroupToDelete={teamsGroupToDelete}
        setTeamsGroupToDelete={setTeamsGroupToDelete}
        contactsGroup={contactsGroup}
        setContactsGroup={setContactsGroup}
      />

      <ContactsSection.components.RenderSection
        idPerson={idPerson}
        formikProps={formikProps}
        formikRef={formikRef}
        idProduct={idProduct}
        globalQuestionnaire={globalQuestionnaire}
        setGlobalQuestionnaire={setGlobalQuestionnaire}
        contactsGroup={contactsGroup}
        setContactsGroup={setContactsGroup}
        contactsGroupToDelete={contactsGroupToDelete}
        setContactsGroupToDelete={setContactsGroupToDelete}
      />
      <ButtonContainer style={{ justifyContent: 'end' }}>
        <Button
          type="button"
          primary
          onClick={async () => {
            GeneralSection.events.handleSave({
              questionnaire: globalQuestionnaire,
              formikRef,
              mc,
              SECTIONS,
              teamsGroup,
              values: formikProps.values,
              refQuestionnaireSent,
              submitFunction,
            })
          }}
        >
          SAVE & REFRESH
        </Button>
      </ButtonContainer>
    </>
  )
}